import Toolbar from '@lcsc-ui/components/ToolBar';
import BaseLayout from '@lcsc-ui/layouts/baseLayout';
import MallDataHeader from '@lcsc-ui/layouts/mallDataHeader';
import ecpCurl from '@lcsc-ui/utils/ecpCurl';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

import OpApi from '@/apis/op';
import StaticdataApi from '@/apis/staticdata';
import wwwApi from '@/apis/www';
import Agent from '@/features/agent';

const metadata = {
  title: ' 代理品牌-立创商城',
  additionalMetaTags: [
    {
      name: 'keywords',
      content: '电子元器件制造商,元器件品牌,立创商城',
    },
    {
      name: 'description',
      content: '立创商城提供国内外3000多家电子元器件制造商产品，正品有保障，物料可追溯，下单最快4小时内发货！',
    },
  ],
};

const Index = (props) => {
  const { resourceData, websiteSectionList } = props;

  return (
    <>
      <NextSeo title={metadata.title} additionalMetaTags={metadata.additionalMetaTags} />
      <Head>
        <link rel="canonical" href={resourceData?.projectConfigVO.lcscWwwUrl + '/agent.html'} />
      </Head>
      <div>
        <BaseLayout
          resourceData={resourceData}
          websiteSectionList={websiteSectionList}
          isLgScreen={false}
          notIndexHeaderAdapter={true}
          hideHeader
        >
          <MallDataHeader currentPageName="agent"></MallDataHeader>
          <Agent {...props}></Agent>
          <Toolbar></Toolbar>
        </BaseLayout>
      </div>
    </>
  );
};

export default Index;

export async function getServerSideProps() {
  const [resourceData, websiteSectionList, websiteMallData, agentData] = await Promise.all([
    ecpCurl(StaticdataApi.resourceList),
    ecpCurl(OpApi.websiteSection),
    ecpCurl(OpApi.getWebsiteMallData),
    ecpCurl(wwwApi.getAgentData),
  ]);
  const mallData = websiteMallData;
  const keysMap = {
    aboutData: '企业简介',
    agentData: '代理品牌',
    joinUsData: '加入我们',
    linkUsData: '联系我们',
  };
  if (Object.keys(mallData).length > 0) {
    Object.keys(keysMap).forEach((key) => {
      mallData[key] = mallData.bannerList.find((t) => t.bannerLocation === keysMap[key]);
    });
  }
  return {
    props: {
      resourceData,
      websiteSectionList,
      mallData,
      agentData,
    },
  };
}
